import PropTypes from "prop-types";



export default function WelcomeWeatherForecastInterface({setIsManageLocationOpen,setIsFetchLocationOpen,pinCodes}) {
  return (
    <div className="flex-1 px-6 mt-[150px] gap-[48px] flex flex-col overflow-y-auto h-full items-center">
      <div className="flex gap-[40px] flex-col items-center max-w-2xl 2xl:max-w-3xl ">
        <h1 className="text-center font-hel font-medium text-[30px] leading-[42px] xl:text-[42px] xl:leading-[56px]">
         Stay Ahead of Weather 
         <br/>
         Disruptions with Smart Forecasting
        </h1>
        <p className="text-center text-[#333333] text-[16px]  font-hel font-medium leading-[26px] ">
          Enter your zip code, and our AI will provide 30-day severe weather <br/> alerts to help plan your business operations.
        </p>
        <div className="flex flex-row gap-[10px] items-center justify-center">
           <button className="text-[16px] leading-[24px] font-medium  font-inter text-black border border-[#00000033] py-[10px] px-[25px] bg-white rounded-[8px]"
           type="button"
           onClick={()=>setIsManageLocationOpen(true)}
           >
            Manage Location
           </button>
          <button
          onClick={() => setIsFetchLocationOpen(true)}
          disabled={pinCodes.length === 0}
          className={`text-[16px] bg-[#1B5C29] text-white leading-[24px] font-medium font-inter py-[10px] px-[25px] rounded-[8px] ${
            pinCodes.length === 0
              ? "opacity-40 cursor-not-allowed"
              : ""
          }`}
        >
          Fetch Data
        </button>

        </div>
      </div>
    </div>
  );
}

WelcomeWeatherForecastInterface.propTypes = {
  handleChatResponse: PropTypes.func.isRequired,
};
